var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_google",
    clipPath: "url(#clip0_254_2485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_2485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_760_7149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_2485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.52 12.273C23.52 11.422 23.4437 10.6039 23.3018 9.81836H12V14.4602H18.4582C18.18 15.9602 17.3346 17.2311 16.0637 18.082V21.093H19.9418C22.2109 19.0039 23.52 15.9274 23.52 12.273Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9999 24.0003C15.2399 24.0003 17.9562 22.9257 19.9416 21.093L16.0634 18.0821C14.9889 18.8021 13.6143 19.2275 11.9999 19.2275C8.87434 19.2275 6.22894 17.1166 5.28526 14.2803H1.27618V17.3894C3.25078 21.3112 7.30894 24.0003 11.9999 24.0003Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.2854 14.2794C5.0454 13.5594 4.90908 12.7904 4.90908 11.9994C4.90908 11.2085 5.0454 10.4394 5.2854 9.71943V6.61035H1.27632C0.463679 8.23035 0 10.0631 0 11.9994C0 13.9358 0.463679 15.7685 1.27632 17.3885L5.2854 14.2794Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 4.77276C13.7617 4.77276 15.3435 5.37816 16.5872 6.56724L20.0291 3.1254C17.9509 1.18908 15.2345 0 12 0C7.30907 0 3.25091 2.68908 1.27631 6.61092L5.28539 9.72C6.22907 6.88368 8.87447 4.77276 12 4.77276Z",
    fill: "#E94235"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_2485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.700c845e534f73db20d3a60983f162c2.svg";
export { ForwardRef as ReactComponent };